import 'datatables.net'
import * as $ from 'jquery'
import { AfterViewInit, Component, ViewEncapsulation } from '@angular/core'
import { IQuestionContextView } from '../question-context-view.interface'
import { Question } from '../../../../../data/models'
import { Form } from '../../../../../forms/models'

@Component({
  selector: 'mp-enhanced-tabular-question-context',
  templateUrl: './enhanced-tabular-question-context.html',
  styleUrls: ['./enhanced-tabular-question-context.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EnhancedTabularQuestionContextComponent implements IQuestionContextView, AfterViewInit {

  public question: Question
  public form: Form<Question>

  private _table: DataTables.Api

  private optionsMap = {
    'sort_dropdown': {
      'pre': this._preSortDropdown,
      'post': this._postSortDropdown
    },
  }

  public ngAfterViewInit(): void {
    $(document).ready(() => {

      $('.enhanced-tabular-question-context table').addClass('table table-responsive table-bordered')
      $('.enhanced-tabular-question-context dataTables_scrollBody').css('max-height', '700px')

      const tableOptions: DataTables.Settings = {
        paging: false,
        searching: false,
        ordering: false,
        info: false,
        lengthChange: false,
        scrollX: true,
        autoWidth: false
      }

      Object.values(this.question.questionContext.options).forEach((option) => {
        this.optionsMap[option['type']]['pre'].call(this, option, tableOptions)
      })

      this._table = $('.enhanced-tabular-question-context table').DataTable(tableOptions)

      Object.values(this.question.questionContext.options).forEach((option) => {
        this.optionsMap[option['type']]['post'].call(this, option, tableOptions)
      })
    })
  }

  public ngOnDestroy(): void {
    if (this._table) {
      this._table.destroy()
    }
  }

  private _preSortDropdown(option: {}, tableOptions: {}): void {
    tableOptions['ordering'] = true
    $('.enhanced-tabular-question-context table').before(`
      <select id="sort-dropdown">
        <option value="0">FEEDBACK</option>
        ${option['options'].map((option) => `<option value="${option['column']}">${option['label']}</option>`).join('')}
      </select>
    `)
    $('#sort-dropdown').on('change', option, this._selectSort.bind(this))
  }

  private _postSortDropdown(option: {}, _tableOptions: {}): void {
    const direction = option['direction'] || 'asc'
    $('.sorting').addClass('disable-dt-sort')
    if (option['default_sort']) {
      this._table.order([parseInt(option['default_sort']), direction]).draw()
    }
  }

  private _selectSort($event): void {
    const direction = $event.data['direction'] || 'asc'
    const select = $event.target as HTMLSelectElement
    this._table.order([parseInt(select.value), direction]).draw()
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/question-context-view/enhanced-tabular-question-context/enhanced-tabular-question-context.component.ts